import { isNullOrUndefined } from '../../_helpers';
import { PrintManager, eDownloadPdfs } from './print_manager';

export class DownloadPdfRequest {
  farmsId: Array<string>;
  idCampaign: number;
  DownloadType: eDownloadPdfs;
  filterPrecosType: string;
  /// filtre order sur  l' Order prestation Type
  filterPrestType: string;
  SfxTitle: string;

  constructor(farmsId: Array<string>, idCampaign: number, exportType: string, _iFilterIntervType: string, _iSfxTitle: string, _ifilterPrestType: string) {

    this.farmsId = farmsId;
    this.idCampaign = idCampaign;
    this.DownloadType = this.convertToDownloadType(exportType);
    this.filterPrecosType = _iFilterIntervType;
    this.SfxTitle = _iSfxTitle;
    this.filterPrestType = !isNullOrUndefined(_ifilterPrestType) ? _ifilterPrestType : null;
  }

  /**
  * convertion des  codes type d'impression en enu type print
  * @param _iExportType code type export
  */
  private convertToDownloadType(_exportType: string): eDownloadPdfs|null {

    switch (_exportType) {
      case 'fertilite':
        return eDownloadPdfs.DiagnosticFertilité;
      case 'potentiel':
        return eDownloadPdfs.DiagnocticPotentiel;
      case 'fumure':
        return eDownloadPdfs.ConseilFumure;
      case "Conseil azote":
        return eDownloadPdfs.ConseilAzote;
      case 'preconisation':
        return eDownloadPdfs.Préconisations;
      case PrintManager.code_Print_Modulation:
        return eDownloadPdfs.Modulations;
      case PrintManager.code_Print_Diag_Annuals:
        return eDownloadPdfs.Annuals;
      case PrintManager.code_Print_Orga_Ferti:
        return eDownloadPdfs.ModePreco;

      case PrintManager.code_Print_Diag_Sp_LAI:
        return eDownloadPdfs.DiagSpLai;

      case PrintManager.code_Print_Advice_Sp_LAI:
        return eDownloadPdfs.AdvicePilotNSpLai;

      case PrintManager.code_Print_Preco_Sp_LAI:
        return eDownloadPdfs.PrecoPilotNSpLai;

      case PrintManager.code_Print_Synt_Fertis:
        return eDownloadPdfs.SynthFertilizerNeeds;
      case PrintManager.code_Print_Synt_Other_Inputs:
        return eDownloadPdfs.SynthOtherInputNeeds;

        case PrintManager.code_Print_Advice_Pk_Ferti_Balance:
          return eDownloadPdfs.AdviceFertiBalancePk;
          case PrintManager.code_Print_Advice_Pk_Init_Balance:
            return eDownloadPdfs.AdviceInitialBalancePk;

            case PrintManager.code_print_regulatory_pilot_lai:
              return eDownloadPdfs.RegulatoryAdviceSp
        default:
          return null;
    }
  }
}



